import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { IS_PRIVATE_API } from '@personal-area/global/http/models';
import { Observable } from 'rxjs';

interface PartnerFollowingParams {
  referralLinkId: string | number;
  registration: boolean;
  partnerUserId?: number;
  partnerKey?: string;
}

const apiUrls = {
  actualFollowing: (referralLinkId: string | number) =>
    `/v1/ibp/referral-link/${referralLinkId}/following`,
  legacyFollowing: () => `/v1/ibp/referral-link-old-following`,
};

@Injectable({
  providedIn: 'root',
})
export class ReferralApiService {
  constructor(private _http: HttpClient) {
  }

  public connectToPartner = (
    connectionParams: PartnerFollowingParams,
  ): Observable<void> => {
    const { referralLinkId, ...payload } = connectionParams;
    return this._http.post<void>(
      apiUrls.actualFollowing(referralLinkId),
      payload,
      { context: new HttpContext().set(IS_PRIVATE_API, true) },
    );
  };

  public connectToPartnerWithLegacyParams = (
    connectionParams: PartnerFollowingParams,
  ): Observable<void> => {
    return this._http.post<void>(apiUrls.legacyFollowing(), connectionParams, {
      context: new HttpContext().set(IS_PRIVATE_API, true),
    });
  };

  public partnerReferrer(name: string): Observable<void> {
    return this._http.post<void>(
      `/v1/ibp/partner-referrer`,
      { name },
      { context: new HttpContext().set(IS_PRIVATE_API, true) },
    );
  }
}
